import React, { useState, useEffect, useContext } from 'react';
import { Button, App } from 'antd';
import { FilePdfOutlined } from '@ant-design/icons';
import { GlobalContext } from '../context/globalContext';
import CPPDPdfGenerator from '../services/cppdPdfGenerator';
import CPPDRelatorioFiltrosModal from './dashboards/Governanca/cppd/CPPDRelatorioFiltrosModal';

interface CppdPdfButtonProps {
 clienteId: string;
 filtros?: any;
 texto?: string;
 dashboardData?: any;
}

// Componente interno que usa o App.useApp()
const CppdPdfButtonInner: React.FC<CppdPdfButtonProps> = ({
 clienteId,
 filtros = {},
 texto = 'Gerar PDF',
 dashboardData
}) => {
 const [loading, setLoading] = useState(false);
 const [modalVisible, setModalVisible] = useState(false);
 const [membrosLista, setMembrosLista] = useState<any[]>([]);
 const [clienteNome, setClienteNome] = useState<string>('Cliente');
 const globalContext = useContext(GlobalContext);
 
 // CORREÇÃO: Usar App.useApp() para acessar message
 const { message } = App.useApp();

 const getClienteName = (): string => {
   const currentCliente = globalContext?.currentCliente;
   
   if (currentCliente) {
     return currentCliente.razao_social ||
            currentCliente.nome ||
            currentCliente.name ||
            'Cliente';
   }

   try {
     const stored = localStorage.getItem('currentCliente');
     if (stored) {
       const parsed = JSON.parse(stored);
       return parsed.razao_social || parsed.nome || parsed.name || 'Cliente';
     }
   } catch (error) {
     // Silenciar erro
   }

   return 'Cliente';
 };

 useEffect(() => {
   setClienteNome(getClienteName());
 }, [globalContext?.currentCliente]);

 const handleClick = async () => {
   try {
     setLoading(true);
     
     // Usar membros do dashboard se disponível, senão array vazio
     const membros = dashboardData?.membrosData || [];
     setMembrosLista(membros);
     setModalVisible(true);
   } catch (error) {
     message.error('Erro ao carregar dados');
   } finally {
     setLoading(false);
   }
 };

 const gerarEVisualizar = async (filtrosRelatorio: any) => {
   try {
     setLoading(true);
     message.loading({ content: 'Gerando relatório...', key: 'pdf-loading', duration: 0 });
     
     const filtrosFinal = {
       ...filtros,
       ...filtrosRelatorio,
       cliente_id: clienteId,
       nomeCliente: getClienteName()
     };
     
     await CPPDPdfGenerator.gerarEVisualizar(clienteId, filtrosFinal);
     
     message.success({ content: 'Relatório gerado com sucesso', key: 'pdf-loading' });
     setModalVisible(false);
   } catch (error) {
     message.destroy('pdf-loading');
     message.error('Erro ao gerar PDF');
   } finally {
     setLoading(false);
   }
 };

 return (
   <>
     <Button
       type="primary"
       icon={<FilePdfOutlined />}
       loading={loading}
       onClick={handleClick}
     >
       {texto}
     </Button>
     
     <CPPDRelatorioFiltrosModal
       visible={modalVisible}
       onCancel={() => setModalVisible(false)}
       onGenerate={gerarEVisualizar}
       clienteId={clienteId}
       clienteNome={clienteNome}
       membrosLista={membrosLista}
       filtrosAtuais={filtros}
       dashboardData={dashboardData}
     />
   </>
 );
};

// Componente principal que envolve com App
const CppdPdfButton: React.FC<CppdPdfButtonProps> = (props) => {
 return (
   <App>
     <CppdPdfButtonInner {...props} />
   </App>
 );
};

export default CppdPdfButton;